import { createContext } from 'react';
export const defaultValue = {
    addModal: () => null,
    addModalComponent: () => null,
    dismissActiveModal: () => null,
    dismissAllModals: () => null,
    footerSafeGap: 0,
    headerSafeGap: 0,
};
export const CFModalProviderContext = createContext(defaultValue);
